// extracted by mini-css-extract-plugin
export default {"display-container":"Display_display-container__nM4fc"};